(function() {
    'use strict';

    angular
        .module('fileUploadApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
                angular.forEach(vm.user.authorities,function(a){
                	if(a=='ROLE_CLIENT'){
                		vm.user.role='Client';
                	}
                	else if(a=='ROLE_PROCESSOR'){
                		vm.user.role='Administrator';
                	}
                	else if(a=='ROLE_ADMIN'){
                		vm.user.role='Master Administrator';
                	}
                }) ;
            });
        }
    }
})();
